import HandleAllAutofills from './HandleAllAutofills';

export default HandleAllAutofills;